import { MDCSelect } from '@material/select';
import Block from '../../block'

export default class MdcSelect extends Block {
    static title = 'mdc-select--webiq'

    init() {
        this.field = new MDCSelect(this.element)
        this.selectElement = this.element.querySelector('select')
    }

    disableSelect() {
        this.element.classList.add('mdc-select--disabled')
        this.selectElement.disabled = true
    }

    enableSelect() {
        this.element.classList.remove('mdc-select--disabled')
        this.selectElement.disabled = false
    }
}